import Play from "@washingtonpost/wpds-assets/asset/play";
import Pause from "@washingtonpost/wpds-assets/asset/pause";
import Loading from "@washingtonpost/wpds-assets/asset/loading";
import Refresh from "@washingtonpost/wpds-assets/asset/refresh";
class State {
  constructor(name, label, icon) {
    this.name = name;
    this.label = label;
    this.icon = icon;
  }
}

export const MediaState = {
  READY: new State("READY", "Listen", Play),
  LOADING: new State("LOADING", "Listen", Loading),
  LOADED: new State("LOADED", "Listen", Loading),
  BUFFER: new State("BUFFER", "Listen", Loading),
  PLAYING: new State("PLAYING", "Pause", Pause),
  PAUSED: new State("PAUSED", "Play", Play),
  ERROR: new State("ERROR", undefined, Refresh)
};
